var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-modal', {
    attrs: {
      "id": "memberNotesModal",
      "modal-class": "client-details-modal",
      "centered": "",
      "size": "lg",
      "hide-footer": "",
      "no-close-on-backdrop": "",
      "hide-header-close": "",
      "v-model": _vm.showNotesModal
    },
    on: {
      "hidden": _vm.onClose
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function fn() {
        return [_c('div', {
          staticClass: "view-clients-header"
        }, [_c('b-button', {
          staticClass: "btn-container",
          attrs: {
            "variant": "close-btn"
          },
          on: {
            "click": function click($event) {
              return _vm.$bvModal.hide('memberNotesModal');
            }
          }
        }, [_c('i', {
          staticClass: "fas fa-times"
        })])], 1)];
      },
      proxy: true
    }])
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('div', {
    staticClass: "form-part"
  }, [_c('div', {
    staticClass: "title-text text-center mb-3"
  }, [_c('h5', [_c('strong', [_vm._v("Notes")])])]), _vm.loading ? _c('div', {
    staticClass: "text-center py-4"
  }, [_c('div', {
    staticClass: "spinner-border",
    attrs: {
      "role": "status"
    }
  }, [_c('span', {
    staticClass: "visually-hidden"
  }, [_vm._v("Loading...")])])]) : _vm.error ? _c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v(" " + _vm._s(_vm.error) + " ")]) : _c('div', [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Status")]), _c('th', [_vm._v("Note")]), _c('th', [_vm._v("File")]), _c('th', [_vm._v("Added By")]), _c('th', [_vm._v("Created At")])])]), _c('tbody', [!_vm.notes.length ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("No notes found")])]) : _vm._e(), _vm._l(_vm.notes, function (item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(item.status_text))]), _c('td', [_vm._v(_vm._s(item.annote))]), _c('td', [item.file ? _c('a', {
      attrs: {
        "href": item.file,
        "target": "_blank"
      }
    }, [_vm._v("View File")]) : _c('span', [_vm._v("-")])]), _c('td', [_vm._v(_vm._s(item.added_by))]), _c('td', [_vm._v(_vm._s(item.created_at))])]);
  })], 2)])])])])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }